// extracted by mini-css-extract-plugin
export default {"testimoinalWrapper":"_3nTSpwLa","text":"_1QDT8GYg"};